export default "__VITE_ASSET__BgDqC3RD__"